<template>
  <div>
    페이지를 찾을 수 없습니다.
  </div>
</template>

<script>
  export default {
    name:"Page404"
  }
</script>
